import * as React from 'react';
import { Breadcrumbs } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import '@swc/helpers';
import { useBrPageContext } from '../../../context/context.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/utils';
import '../../../utils/http-client.js';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../../operations/mutations/signup-promotion.js';
import '../../../operations/mutations/subscribe-newsletter.js';
import '../../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import { useBloomreachProductRoutes } from '../../../hooks/use-bloomreach-product-routes.js';
import '../../../hooks/use-breakpoint-visibility.js';
import { createProductBreadcrumb } from './utils/create-product-breadcrumb.js';
import { createSubCategoryBreadcrumb } from './utils/create-subcategory-breadcrumb.js';
import { createCategoryBreadcrumb } from './utils/create-category-breadcrumb.js';

const CmsProductBreadcrumbs = ({ product , sku  })=>{
    var ref;
    const { locale  } = useIntl();
    const page = useBrPageContext();
    if (!page) {
        console.error(`Missing Page from Bloomreach.`);
    }
    const { isSubcategoryPlpLinkingDisabled  } = useFeatureToggles();
    const productType = (ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name;
    const [, productRoutes] = useBloomreachProductRoutes();
    const categoryRoute = productRoutes[productType];
    if (!categoryRoute) {
        console.warn('Could not find a product category route to render PDP breadcrumbs');
        return null;
    }
    const categoryBreadcrumb = createCategoryBreadcrumb(categoryRoute, page);
    const subCategoryBreadcrumb = isSubcategoryPlpLinkingDisabled ? null : createSubCategoryBreadcrumb(categoryRoute, product, productType, locale, page);
    const productBreadcrumb = createProductBreadcrumb(categoryBreadcrumb, product, productType, sku, locale);
    const breadcrumbs = [
        categoryBreadcrumb,
        subCategoryBreadcrumb,
        productBreadcrumb
    ].filter(Boolean);
    return /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Breadcrumbs, {
        pages: breadcrumbs
    }));
};

export { CmsProductBreadcrumbs, CmsProductBreadcrumbs as default };
//# sourceMappingURL=ProductBreadcrumbs.js.map
